import { BadRequest, ServiceUnavailable } from 'common/errors'
import { useEffect, useState } from 'react'
import { login } from '../api/website-public-page-api'
import { PublicPageFieldSlugEnum } from '../enums/public-page-field-slug-enum'
import { validateEmailField, validateEmptyField } from '../utils/validation'

type ErrorFields = Partial<Record<PublicPageFieldSlugEnum | 'root', string[]>>

export const useLoginSubmit = () => {
  const [loading, setLoading] = useState(false)
  const [errors, setErrors] = useState<ErrorFields>()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [rememberMe, setRememberMe] = useState(false)

  useEffect(() => {
    if (
      errors?.[PublicPageFieldSlugEnum.Email] ||
      errors?.[PublicPageFieldSlugEnum.Password]
    ) {
      setErrors(undefined)
    }
  }, [email, password])

  const handleSubmit = async () => {
    const emailEmptyError = validateEmptyField(email)
    if (emailEmptyError && emailEmptyError.length > 0) {
      setErrors({ [PublicPageFieldSlugEnum.Email]: emailEmptyError })
      return
    }
    const emailFormatError = validateEmailField(email)
    if (emailFormatError && emailFormatError.length > 0) {
      setErrors({ [PublicPageFieldSlugEnum.Email]: emailFormatError })
      return
    }
    const passwordEmptyError = validateEmptyField(password)
    if (passwordEmptyError && passwordEmptyError.length > 0) {
      setErrors({ [PublicPageFieldSlugEnum.Password]: passwordEmptyError })
      return
    }

    setErrors(undefined)
    try {
      setLoading(true)
      const response = await login({ email, password, rememberMe })
      const responseUrl = (response.request as { responseURL?: string })
        ?.responseURL
      const redirect = response.data?.redirect

      if (responseUrl?.includes('/2fa')) {
        window.location.replace(responseUrl)
        return
      }
      window.location.replace(redirect)
    } catch (e) {
      if (e instanceof ServiceUnavailable) {
        setErrors({ root: ['core.errors.service_temporary_unavailable'] })
      } else if (e instanceof BadRequest) {
        const { fields, common } = e.response.data.errors || {}

        const newErrors: ErrorFields = {}
        if (fields) {
          Object.entries(fields).forEach(([key, messages]) => {
            if (key === PublicPageFieldSlugEnum.Email) {
              newErrors[PublicPageFieldSlugEnum.Email] = [messages?.join('\n')]
            }
            if (key === PublicPageFieldSlugEnum.Password) {
              newErrors[PublicPageFieldSlugEnum.Password] = [
                messages?.join('\n'),
              ]
            }
          })
        }
        if (common) {
          newErrors.root = [common?.join('\n')]
        }
        setErrors(newErrors)
      }
    } finally {
      setLoading(false)
    }
  }

  return {
    loading,
    errors,
    email,
    setEmail,
    password,
    setPassword,
    rememberMe,
    setRememberMe,
    handleSubmit,
  }
}
